import { useInfiniteQuery } from 'react-query';
import pecaAiServices from './pecaAi.services';
import { EnterprisePecaAiSearchProductRequest } from './pecaAi.types';

export function useEnterprisePecaAiSearchProduct(
  params?: EnterprisePecaAiSearchProductRequest,
  enabled = true,
) {
  return useInfiniteQuery(
    ['enterprise/peca-ai/search-product', { ...params }],
    ({ pageParam }) =>
      pecaAiServices.searchProduct({ ...params, nextToken: pageParam }),
    {
      enabled: enabled,
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}
